import { PolicyCreateAdapter } from '../../../adapter';

export default async function PolicyCreateUseCase(event) {
    const { autoRenewTag } = event;
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcr.dev.bpimsapps.com');
    const isUAT = url.includes('hcr.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionrenewal.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
            ? `https://partners-api.dev.bpimsapps.com/${autoRenewTag ? 'register' : 'register/onetime/v2'}`
            : isUAT
                ? `https://partners-api.uat.bpimsapps.com/${autoRenewTag ? 'register' : 'register/onetime/v2'}`
                : isProd
                    ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${flag ? '' : '/partners'}/${autoRenewTag ? (flag ? 'register' : 'register/recurring') : 'register/onetime-new/v2'}`
                    : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${flag ? '' : '/partners'}/${autoRenewTag ? (flag ? 'register' : 'register/recurring') : 'register/onetime-new/v2'}`;

    const payload = { 
        policy : { ...event} 
    };

    console.log("payload",  payload);

    // handle request
    const result = await PolicyCreateAdapter(endpoint, JSON.stringify(payload));

    return result;
}
